import {
  IngestionSourceType,
  type KafkaSourceProperties,
  SchemaRegistryAuthType,
} from '@repo/api-gw-sdk';

import type { IngestionPipelineWizardState } from './IngestionPipelineWizardState';

const S3_GCS_LABELS = ['Pipeline Details', 'Source', 'Partitioning', 'Review'];
const KAFKA_LABELS = [
  'Pipeline Details',
  'Source',
  'Security',
  'Schema Registry',
  'Settings',
  'Review',
];

export function getStepperLabels(sourceType: IngestionSourceType): string[] {
  if (sourceType === IngestionSourceType.INGESTION_SOURCE_TYPE_KAFKA) {
    return KAFKA_LABELS;
  }
  return S3_GCS_LABELS;
}

export function buildKafkaSourceProperties(
  state: IngestionPipelineWizardState
): KafkaSourceProperties {
  return {
    source: {
      bootstrapServers: state.kafkaBootstrapServers
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean),
      topic: state.kafkaTopic,
      consumerGroupId: state.kafkaConsumerGroupId || undefined,
      startingOffset: state.kafkaStartingOffset,
      messageFormat: state.kafkaMessageFormat,
      keyHandling: state.kafkaKeyHandling,
    },
    security: {
      securityProtocol: state.kafkaSecurityProtocol,
      saslMechanism: state.kafkaSaslMechanism
        ? (state.kafkaSaslMechanism as KafkaSourceProperties['security']['saslMechanism'])
        : undefined,
      credentialsSecretArn: state.kafkaCredentialsSecretArn || undefined,
      tlsSecretArn: state.kafkaTlsSecretArn || undefined,
    },
    schemaRegistry: state.kafkaSchemaRegistryEnabled
      ? {
          url: state.kafkaSchemaRegistryUrl,
          auth: {
            type: state.kafkaSchemaRegistryAuthType,
            credentialsSecretArn:
              state.kafkaSchemaRegistryCredentialsSecretArn || undefined,
            tlsSecretArn: state.kafkaSchemaRegistryTlsSecretArn || undefined,
          },
          subjectNamingStrategy: state.kafkaSubjectNamingStrategy
            ? (state.kafkaSubjectNamingStrategy as KafkaSourceProperties['schemaRegistry']['subjectNamingStrategy'])
            : undefined,
          evolutionMode: state.kafkaSchemaEvolutionMode,
        }
      : {
          url: '',
          auth: {
            type: SchemaRegistryAuthType.SCHEMA_REGISTRY_AUTH_TYPE_NONE,
          },
        },
    partitioning: {
      strategy: state.kafkaPartitioningColumns
        .map((s) => s.trim())
        .filter(Boolean),
    },
    batch: {
      mode: state.kafkaBatchMode,
      maxRecordsPerBatch: state.kafkaMaxRecordsPerBatch
        ? parseInt(state.kafkaMaxRecordsPerBatch, 10)
        : undefined,
      maxBatchIntervalSeconds: state.kafkaMaxBatchIntervalSeconds
        ? parseInt(state.kafkaMaxBatchIntervalSeconds, 10)
        : undefined,
    },
    errorHandling: {
      onError: state.kafkaErrorPolicy,
      maxRetries: state.kafkaMaxRetries
        ? parseInt(state.kafkaMaxRetries, 10)
        : 3,
    },
  };
}
